
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.402 2.241A1.57 1.57 0 001.711.671a1.575 1.575 0 10-.04 3.141h.02a1.578 1.578 0 001.711-1.57zm-.2 2.81H.178v9.088h3.024V5.052zm7.426-.213c1.99 0 3.482 1.3 3.482 4.09v5.21h-3.023V9.277c0-1.221-.438-2.055-1.533-2.055a1.656 1.656 0 00-1.552 1.104 2.08 2.08 0 00-.1.737v5.075H4.878s.04-8.234 0-9.087h3.025V6.34a3.004 3.004 0 012.726-1.5v-.001z","fill":"currentColor"}})])
          )
        }
      }
    